import React from 'react'
import styled from 'styled-components/native'

import { FileUploadProvider } from './provider'
import { FileUploadError } from './error'
import { FileUploadContent } from './content'
import { FileUploadTitle } from './title'
import { SupportedFileWithMetadata } from 'APP/Converse/FilePreview/types'

export const FileUploadContainer = styled.View`
  color: rgba(0, 0, 0, 0.5);
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
`

export type FileUploadInputProps = {
  title?: string
  errorMessage?: string
  onPress?: (fileIndexToReplace?: number) => void
  testId?: string
  files?: SupportedFileWithMetadata[]
  maxFiles?: number
  onRemove?: (file: SupportedFileWithMetadata, index: number) => void
  isLoading?: boolean
  allowMultiple?: boolean
}

/**
 *
 * FileUploadInput component
 *
 * @param {FileUploadInputProps} props - The props for the FileUploadInput component.
 * @returns {JSX.Element} The rendered FileUploadInput component.

 */
function FileUploadInput({
  title = '',
  errorMessage,
  onPress,
  testId = 'FILE_UPLOAD_INPUT',
  files = [],
  maxFiles = 1,
  onRemove,
  isLoading = false,
  allowMultiple = false,
}: FileUploadInputProps) {
  return (
    <FileUploadProvider
      title={title}
      errorMessage={errorMessage}
      onPress={onPress}
      testId={testId}
      files={files}
      maxFiles={maxFiles}
      onRemove={onRemove}
      isLoading={isLoading}
      allowMultiple={allowMultiple}
    >
      <FileUploadContainer>
        <FileUploadTitle />
        <FileUploadContent />
        <FileUploadError />
      </FileUploadContainer>
    </FileUploadProvider>
  )
}

export default FileUploadInput
